<template>
	<div class="w-full rounded documentCard">
		<div class="flex bg-white">
			<div
				v-if="!hasDocuments && isAppContainer"
				:class="{ active: tab === 'save_documents' }"
				class="tab"
				@click="
					tab = 'save_documents';
					fetchDocuments();
				"
			>
				{{ evaluateHeader('save_documents', $t('store')) }}
			</div>
			<div
				:class="{ active: tab === 'upload' }"
				class="tab"
				@click="
					tab = 'upload';
					fetchDocuments();
				"
			>
				{{ evaluateHeader('upload', $t('administrate')) }}
			</div>
			<div
				:class="{ active: tab === 'sent_email' }"
				class="tab"
				@click="
					tab = 'sent_email';
					fetchDocuments();
				"
			>
				{{ evaluateHeader('sent_email', $t('send_per_e_mail')) }}
			</div>
			<div
				v-if="isUserAllowedInLevel5or6"
				:class="{ active: tab === 'unblock_documents_in_app' }"
				class="tab"
				@click="
					tab = 'unblock_documents_in_app';
					fetchDocuments();
				"
			>
				{{ evaluateHeader('unblock_documents_in_app', $t('access_in_app')) }}
			</div>
			<div
				v-if="hasDocuments && isAppContainer"
				:class="{ active: tab === 'save_documents' }"
				class="tab"
				@click="
					tab = 'save_documents';
					fetchDocuments();
				"
			>
				{{ evaluateHeader('save_documents', $t('store')) }}
			</div>
			<div
				:class="{ active: tab === 'sign_documents' }"
				class="tab"
				@click="
					tab = 'sign_documents';
					fetchDocuments();
				"
				v-if="isUserAllowedInLevel5or6"
			>
				{{ evaluateHeader('sign_documents', $t('let_sign')) }}
			</div>
		</div>

		<div>
			<ProcessDocumentUploadTab v-show="tab === 'upload'" :process="process" :is-system-damage-assessor="isSystemDamageAssessor" />
			<ProcessDocumentSentMailTab v-show="tab === 'sent_email'" :process="process" />
			<ProcessDocumentUnblockDocumentsInAppTab
				v-if="isUserAllowedInLevel5or6"
				v-show="tab === 'unblock_documents_in_app'"
				:process="process"
				:is-active="tab === 'unblock_documents_in_app'"
			/>
			<ProcessDocumentCreateTab v-if="isUserAllowedInLevel5or6" v-show="tab === 'save_documents'" :process="process" />
			<ProcessDocumentsSignTab v-if="isUserAllowedInLevel5or6" v-show="tab === 'sign_documents'" :process="process" />
		</div>
	</div>
</template>

<script>
import ProcessDocumentUploadTab from '@/views/management/Process/Document/ProcessDocumentUploadTab';
import ProcessDocumentSentMailTab from '@/views/management/Process/Document/ProcessDocumentSentMailTab';
import Authentication from '@/mixins/Authentication';
import ProcessDocumentUnblockDocumentsInAppTab from '@/views/management/Process/Document/ProcessDocumentUnblockDocumentsInAppTab';
import ProcessDocumentCreateTab from '@/views/management/Process/Document/ProcessDocumentCreateTab.vue';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import ProcessDocumentsSignTab from '@/views/management/Process/Document/ProcessDocumentsSignTab.vue';

export default {
	name: 'ProcessDocuments',
	mixins: [Authentication, AppContainerMixin],
	components: {
		ProcessDocumentsSignTab,
		ProcessDocumentCreateTab,
		ProcessDocumentUnblockDocumentsInAppTab,
		ProcessDocumentSentMailTab,
		ProcessDocumentUploadTab,
	},
	props: {
		process: { required: true },
		isSystemDamageAssessor: { default: true },
	},
	computed: {
		hasDocuments() {
			if (
				this.$store.getters.getDocumentsRepairShop === undefined ||
				this.$store.getters.getDocumentsLawyer === undefined ||
				this.$store.getters.getDocumentsDamageAssessor === undefined
			) {
				return false;
			} else {
				let realDocuments = this.$store.getters.getDocumentsRepairShop.filter(document => document.uuid != null);
				realDocuments += this.$store.getters.getDocumentsLawyer.filter(document => document.uuid != null);
				realDocuments += this.$store.getters.getDocumentsDamageAssessor.filter(document => document.uuid != null);
				return realDocuments.length > 0;
			}
		},
	},
	methods: {
		fetchDocuments() {
			this.$store.dispatch('updateDocuments', { id: this.$route.params.processId });
		},
		evaluateHeader(tab, title) {
			if (tab === this.tab) {
				return this.$t('documents') + ' ' + title;
			} else {
				return '... ' + title;
			}
		},
	},
	mounted() {
		if (this.$route.params.scrollToDocs) {
			this.tab = this.$route.params.scrollToDocs;
		} else {
			if (!this.hasDocuments && this.isAppContainer) {
				this.tab = 'save_documents';
			} else {
				this.tab = 'upload';
			}
		}
	},
	data() {
		return {
			tab: 'save_documents',
		};
	},
	watch: {
		hasDocuments(newValue) {
			if (!newValue && this.isAppContainer) {
				this.tab = 'save_documents';
			} else {
				this.tab = 'upload';
			}
		},
	},
};
</script>

<style scoped>
.tab {
	@apply text-gray-500 bg-gray-200 font-bold cursor-pointer px-5 py-6 leading-none rounded border-t border-r border-l box-border;
	font-size: 18px;
}

.tab.active {
	@apply text-connectProBlue bg-black border-transparent;
	--bg-opacity: 0.04;
}

.documentCard {
	@apply bg-black;
	--bg-opacity: 0.04;
}
</style>
